export function reportGuestActivity(words: number, keepalive = false) {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (!url || !key) return;
  void fetch(`${url}/functions/v1/guest-activity`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', apikey: key },
    body: JSON.stringify({ words: Math.max(0, Math.min(10000000, Math.round(words))) }),
    keepalive,
  }).catch(() => {});
}
